import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'dadyin-searchable-select',
  templateUrl: './dadyin-searchable-select.component.html',
  styleUrls: ['./dadyin-searchable-select.component.scss'],
})
export class DadyinSearchableSelectComponent implements OnInit {
  @Input() class: any;
  @Input() label: any;
  @Input() fullItems: any;
  @Input() bindValue: any = 'id';
  @Input() bindLabel: any = 'description';
  @Input() control: any = new FormControl();
  @Input() placeholder: any = '';
  @Output() changed: any = new EventEmitter();
  @Input() isDisabled: any = false;
  @Input() multiple = false;
  @Input() optionTag = null;
  constructor() {}

  ngOnInit(): void {}

  customSearchFn = (term: string, item: any): boolean => {
    if (!term || !item) return false;
    const itemText = item[this.bindLabel]
      ?.toString()
      .toLowerCase()
      .replace(/,/g, '');
    if (!itemText) return false;
    const [firstPart, secondPart = ''] = term
      .split(',')
      .map((part) => part.trim());
    const keywords = firstPart
      .split(' ')
      .map((word) =>
        (word + (secondPart ? ` ${secondPart}` : '')).toLowerCase()
      );
    // Also check the original term in case there's no comma
    if (!term.includes(',')) {
      keywords.push(term.toLowerCase());
    }
    return keywords.some((keyword) => {
      const keywordParts = keyword.split(' ');
      return keywordParts.every((part) => itemText.includes(part));
    });
  };

  onChange() {
    this.changed.emit(this.control?.value);
  }
}
